<template>
	<form class="form-horizontal">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<b-col sm="6" class="mb-2">
                        <b-form-group label="Tanggal Import">
							{{ models.tglImport | formatDate }}
						</b-form-group>
                        <b-form-group label="Kode Fasyankes">
							{{ models.kodeFasyankesPelakuUsaha }}
						</b-form-group>
                    </b-col>
					<b-col sm="6" class="mb-2">
                        <b-form-group label="Limbah B3">
							{{ models.limbahB3 ? models.limbahB3.namaLimbah : "-" }}
						</b-form-group>
						<b-form-group label="Nomor Manifest">
							{{ models.nomorManifest || "-" }}
						</b-form-group>
                    </b-col>
					<b-col sm="6" class="mb-2">
						<b-form-group label="Tanggal Diangkut">
							{{ models.tglDiangkut | formatDate }}
						</b-form-group>
                        <b-form-group label="Perusahaan Pengangkut">
							{{ models.perusahaanPengangkut }}
						</b-form-group>
                        <b-form-group label="Berat Diangkut">
							{{ models.beratDiAngkut }}
						</b-form-group>
					</b-col>
                    <b-col sm="6" class="mb-2">
						<b-form-group label="Tanggal Diterima">
							{{ models.tglDiterima | formatDate }}
						</b-form-group>
                        <b-form-group label="Perusahaan Penerima">
							{{ models.perusahaanPenerima }}
						</b-form-group>
                        <b-form-group label="Berat Diterima">
							{{ models.beratDiTerima }}
						</b-form-group>
					</b-col>
				</b-row>
				<template #footer>
					<b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';
	import { getJenisFasyankesById } from '@/utils/helpers';

	export default {
		name: 'ViewSiraja',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
				},
				models: {
                    limbahB3: {}
                },
			}
		},
		created() {
			const _ = this
			_.getById();
		},
		methods: {
			async getById() {
				const _ = this;
				try {
					if (_.$route.params.id) {
						const request = await _.$axios.get(`Siraja/${_.$route.params.id}`);
						_.models = request.data.data;
					}
				} catch (error) {
					_.$router.push({ name: 'page404' });
				}
				
			},
            get(id) {
                return getJenisFasyankesById(id);
            }
		}
	}
</script>